export default {
  path: '/travel-documents/disposition/:id',
  name: 'DispositionDetailsView',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/DispositionDetailsView.vue')
}
